import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/exit-intent")({
  component: lazyRouteComponent(() => import("./-pages/admin.exit-intent")),
});
